// Wallet detection helpers - EIP-1193 injected providers
// Supports Trust Wallet, MetaMask, Binance, and other injected wallets

export const detectWallets = () => {
  const wallets = [];
  const eth = window.ethereum;

  if (!eth) return wallets;

  // EIP-6963: multi-provider environments
  if (eth.providers && Array.isArray(eth.providers)) {
    eth.providers.forEach((p) => {
      wallets.push(identifyProvider(p));
    });
  } else {
    wallets.push(identifyProvider(eth));
  }

  // Trust Wallet standalone
  if (window.trustwallet && !wallets.some((w) => w.name === 'Trust Wallet')) {
    wallets.push({ name: 'Trust Wallet', provider: window.trustwallet, icon: '🛡️' });
  }

  // BinanceChain
  if (window.BinanceChain && !wallets.some((w) => w.name === 'Binance Wallet')) {
    wallets.push({ name: 'Binance Wallet', provider: window.BinanceChain, icon: '🟡' });
  }

  return wallets;
};

const identifyProvider = (p) => {
  if (!p) return { name: 'Unknown', provider: p, icon: '👛' };
  if (p.isTrust || p.isTrustWallet) return { name: 'Trust Wallet', provider: p, icon: '🛡️' };
  if (p.isMetaMask && !p.isBraveWallet) return { name: 'MetaMask', provider: p, icon: '🦊' };
  if (p.isBraveWallet) return { name: 'Brave Wallet', provider: p, icon: '🦁' };
  if (p.isCoinbaseWallet) return { name: 'Coinbase', provider: p, icon: '🔵' };
  if (p.isTokenPocket) return { name: 'TokenPocket', provider: p, icon: '💼' };
  if (p.isSafePal) return { name: 'SafePal', provider: p, icon: '🔐' };
  if (p.isImToken) return { name: 'imToken', provider: p, icon: '🪙' };
  if (p.isRabby) return { name: 'Rabby', provider: p, icon: '🐰' };
  if (p.isOkxWallet || p.isOKExWallet) return { name: 'OKX Wallet', provider: p, icon: '⭕' };
  if (p.isBinance || p.isBinanceChainWallet) return { name: 'Binance Wallet', provider: p, icon: '🟡' };
  return { name: 'Injected Wallet', provider: p, icon: '👛' };
};

export const isMobile = () => {
  return /android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent);
};

export const isInWalletBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return (
    !!window.ethereum ||
    !!window.trustwallet ||
    !!window.BinanceChain ||
    ua.includes('trust') ||
    ua.includes('metamask') ||
    ua.includes('safepal') ||
    ua.includes('tokenpocket') ||
    ua.includes('imtoken')
  );
};

export const getDefaultProvider = () => {
  const eth = window.ethereum;
  if (!eth) return null;
  // If multiple providers, prefer the first that matches an identified wallet
  if (eth.providers && Array.isArray(eth.providers)) {
    // Prefer Trust > MetaMask > others
    const trust = eth.providers.find((p) => p.isTrust || p.isTrustWallet);
    if (trust) return trust;
    const mm = eth.providers.find((p) => p.isMetaMask);
    if (mm) return mm;
    return eth.providers[0];
  }
  return eth;
};
